/**
 * Given a selector and callback, runs the callback providing each element as the first argument.
 *
 * @param {string} selector - The document query selector
 * @param {function} callback - The callback to return for each element
 */
export default function forEachSelector(selector, callback) {
  selectAll(selector).forEach(callback);
}

export function selectAll(selector){
  return Array.from(document.querySelectorAll(selector));
}
